import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaPeriodoFim = (): TabelaColuna => ({
  Chave: 'dataFimPesquisa',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <span>{formatadores.dataLocaleString(linha.dataFimPesquisa)}</span>
  ),
  RenderizarCabecalho: () => <div style={{ width: 200 }}>Periodo Fim</div>
})
